<h1 matDialogTitle>Invoice Refund Payment</h1>

<mat-dialog-content>

  <ng-container *ngIf="invoice; else loading">
    <div>
      <table style="width: 100%;">
        <tr>
          <th rowspan="2" class="th-label" style="vertical-align: top;">Invoice</th>
          <td rowspan="2" class="td-value" style="text-align: right; padding-right: 16px;vertical-align: top;">
            {{invoice.invoiceNumber}}</td>
          <th class="th-label">Total</th>
          <td class="td-value" style="text-align: right;">{{invoice.invoiceAmount | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <!-- <th class="th-label">Invoice</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.invoiceNumber}}</td> -->
          <th class="th-label">Balance</th>
          <td class="td-value" style="text-align: right;">{{invoice.invoiceBalance | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <th class="th-label">Sales Order</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.salesOrderNumber}}</td>
          <th class="th-label">Balance (Dep.)</th>
          <td class="td-value" style="text-align: right;">{{invoice.depositBalance | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <th class="th-label">Customer</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.customer}}</td>
          <th class="th-label">Balance (Acc.)</th>
          <td class="td-value" style="text-align: right;">{{invoice.accountBalance | number:'1.2-2'}}</td>
        </tr>

      </table>
    </div>
    <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" (refundReasonChanged)="refundReasonChanged($event)" [paymentType]="'REFUND'"
      [amountOutstanding]="invoice.invoiceBalance" [salesOrderNumber]="invoice.salesOrderNumber"
      [invoiceNumber]="invoice.invoiceNumber"></app-pos-capture-payment>
    <!-- <mat-form-field style="width: 300px; margin-right: 16px">
      <mat-label>Approved By Manager Email</mat-label>
      <input matInput type="email" [(ngModel)]="approvedByEmail" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field style="width: 300px;">
      <mat-label>Approved By Manager Password</mat-label>
      <input matInput type="password" [(ngModel)]="approvedByPwd" autocomplete="new-password">
    </mat-form-field> -->
  </ng-container>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>



</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <!-- <button [disabled]="!formValid || approvedByEmail?.length <= 0 || approvedByPwd?.length <= 0" mat-button -->
  <button [disabled]="!formValid || !refundReasonId" mat-button
    (click)="save()">Save</button>
</mat-dialog-actions>
